import { Box, Skeleton } from "@mui/material";
import { type FC, useState } from "react";
import { type RandomRange, randomBetween, randomCount } from "./skeletonVariants";

/** The narrowest a card gets before the grid wraps to fewer per row. */
const CARD_MIN_WIDTH = "12rem";
/** How the cards vary per mount: how many there are, and each card's label and figure width (% of the card). */
const CARDS_RANGES = {
	cards: [4, 6],
	labelWidth: [40, 70],
	figureWidth: [30, 60],
} as const satisfies Record<string, RandomRange>;

/** A grid of stat cards: a label, a large figure and a caption, each card's bars at their own random widths. */
export const CardsSkeletonVariant: FC = () => {
	const [cards] = useState(() =>
		Array.from({ length: randomCount(CARDS_RANGES.cards) }, () => ({
			labelWidth: randomBetween(CARDS_RANGES.labelWidth),
			figureWidth: randomBetween(CARDS_RANGES.figureWidth),
		})),
	);

	return (
		<Box sx={{ display: "grid", gridTemplateColumns: `repeat(auto-fill, minmax(${CARD_MIN_WIDTH}, 1fr))`, gap: 2 }}>
			{cards.map((card, index) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: placeholder cards are a fixed set of bars; nothing reorders them.
				<Box key={index} sx={{ display: "flex", flexDirection: "column", gap: 1, p: 2, border: 1, borderColor: "divider", borderRadius: 1 }}>
					<Skeleton variant="text" width={`${card.labelWidth}%`} />
					<Skeleton variant="text" width={`${card.figureWidth}%`} sx={{ typography: "h4" }} />
					<Skeleton variant="text" width="50%" />
				</Box>
			))}
		</Box>
	);
};
